/**
 * Validação de senha no frontend (espelha regras do Django).
 * Usado para mostrar erros antes do usuário clicar em Criar conta.
 */

const SENHAS_COMUNS = new Set([
  'password', '12345678', '123456', '123456789', '1234567890',
  'qwerty', 'abc123', 'password1', '111111', '123123', 'admin',
  'letmein', 'welcome', 'monkey', 'dragon', 'master', 'sunshine',
  'princess', 'football', 'iloveyou', 'admin123', '12341234',
  '123321', '654321', 'superman', 'qazwsx', 'michael', 'shadow',
  'senha', 'senha123', 'brasil', '12345678910', '1234', '12345',
].map((s) => s.toLowerCase()));

export const validatePassword = (value) => {
  if (!value) return null;
  const v = String(value);
  if (v.length < 8) {
    return 'Mínimo de 8 caracteres';
  }
  if (/^\d+$/.test(v)) {
    return 'Esta senha não pode ser apenas números';
  }
  if (SENHAS_COMUNS.has(v.toLowerCase())) {
    return 'Esta senha é muito comum. Escolha uma senha mais segura';
  }
  return null;
};
